
import { Component, Vue } from 'vue-property-decorator'
import TicketScgl from '@/views/Ticket/indexScgl.vue'

@Component({
  name: 'AllOrderLists',
  components: {
    TicketScgl
  }
})
export default class extends Vue {}
